import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import { ROUTES, STATES } from '../../../lib/routes'

/**
 * =======================================
 * ROUTES CONFIG - API
 * =======================================
 *
 * @module webregister.routes.api
 */
function ApiRoutesConfig($stateProvider: StateProvider) {
  $stateProvider.state(STATES.API_LOAD_SALE, {
    url: ROUTES.API_LOAD_SALE,
    onEnter($state: $TSFixMe, $stateParams: $TSFixMe) {
      if ($stateParams && $stateParams.action === 'view') {
        window.location.href = `${ROUTES.NEW_SALES_HISTORY_REDIRECT}/${$stateParams.sale}`
        return
      }

      return $state.target(STATES.SALE, {
        ...$stateParams,
        closeAfterComplete: $stateParams.close_after_complete === 'true',
      })
    },
  })
  // Registering quotes endpoint
  $stateProvider.state(STATES.API_LOAD_QUOTE, {
    url: ROUTES.API_LOAD_QUOTE,
    onEnter($state: $TSFixMe, $stateParams: $TSFixMe) {
      return $state.target(STATES.SALE, {
        ...$stateParams,
      })
    },
  })
}

angular.module('webregister.routes').config(ApiRoutesConfig)
